export const ERROR = 'error';
export const LOADING = 'loading';
